// project imports

// assets
import AppstoreAddOutlined from '@ant-design/icons/AppstoreAddOutlined';
import SecurityScanOutlined from '@ant-design/icons/SecurityScanOutlined';

// type
import { NavItemType } from 'types/menu';

// ==============================|| MENU ITEMS - APPLICATIONS ||============================== //

const restaurant: NavItemType = {
  id: 'group-waiter-search',
  title: 'Staff search',
  icon: AppstoreAddOutlined,
  type: 'group',
  children: [
    {
      id: 'find-waiter',
      title: 'Find staff',
      type: 'item',
      url: '/restaurant/search',
      icon: SecurityScanOutlined,
      breadcrumbs: false
    }
  ]
};

export default restaurant;
